import type { ListResponse } from '../../goodstack'
import type { GivingCampaignPartnerDto } from '../campaign.types'

import type { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { GetMyCampaignsQueryParams } from './getMyCampaigns.types'

export const getMyCampaigns: InfiniteQueryFn<
  [string, GetMyCampaignsQueryParams],
  string,
  ListResponse<GivingCampaignPartnerDto>
> = async (client, [_, { direction = 'ASC', pageSize = 25, ...params }], cursor) =>
  (
    await (cursor
      ? client.get<ListResponse<GivingCampaignPartnerDto>>(cursor, {
          withCredentials: true
        })
      : client.get<ListResponse<GivingCampaignPartnerDto>>('v1/account/giving-campaigns', {
          params: { direction, pageSize, ...params },
          withCredentials: true
        }))
  ).data
